export const apiHost = process.env.REACT_APP_CORE_HOST;
export const menuAppHost = process.env.REACT_APP_MENU_HOST;
export const s3BucketUrl = process.env.REACT_APP_S3_BUCKET;
export const fallbackLng = process.env.REACT_APP_FALLBACK_LANGUAGE;